import { cn } from '@/lib/utils';

interface AppAvatarProps {
  src?: string;
  alt?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  xs: 'h-6 w-6',
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-12 w-12',
};

function AppAvatar({ src, alt = 'Avatar', size = 'md', className }: AppAvatarProps) {
  return (
    <div className="flex items-center">
      <img
        src={src}
        alt={alt}
        className={cn(
          'rounded-full object-cover',
          sizeClasses[size],
          className
        )}
      />
    </div>
  );
}

export default AppAvatar;
